import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { CaretLeftSmall } from "@vitalsource/vstui/icons";
import { Button } from "@vitalsource/vstui/";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import { Translation } from "../../../core/translate";
import SearchForm from "./search-container/explore-search";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import {
  getCurrentRoute,
  getSubscriptionFromRoute
} from "../../../../redux/router/selectors";
import { magic } from "@vitalsource/vstui/colors";
import { selectors as routerSelectors } from "../../../../redux/router";

const Styled = {
  HeroContainer: styled.div`
    width: 100%;
    max-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 0;
    position: relative;
    margin-bottom: 30px;
    background-color: ${props => (props.titleText ? "#262d40" : magic.getShade(8))};
    clip-path: ${props => (props.titleText ? "0" : "polygon(100% 0, 100% 100%, 0% 80%, 0 0%)")};
    overflow: hidden;
    z-index: 1;
    &:before {
      content: " ";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      opacity: 0.4;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: ${props => `url('${props.backgroundImage}')`};
    }
    ${styledMedia.small`
    max-height: 485px;
    `}
  `,
  BackButton: styled(Button)`
    left: 5px;
    position: absolute;
    top: 5px;
    z-index: 2;
  `,
  Header: styled.h2`
    font-size: 5.6rem;
    font-weight: 500;
    color: #ffffff;
    padding-bottom: 16px;
    position: relative;
    text-align: center;
    z-index: 3;
    ${styledMedia.small`
      font-size: 4.2rem;
      padding: 0 38px 25px;
    `}
  `,
  Description: styled.h3`
    color: ${props => props.theme.vstui.color.white};
    font-size: 2.4rem;
    font-weight: 400;
    text-align: center;
    width: 627px;
    z-index: 3;
    a {
      color:${props => props.theme.vstui.color.white};
      font-size: 2.4rem;
    }
    ${styledMedia.small`
      font-size: 1.6rem;
      padding: 0 10px;
      width: auto;
  `}
  `,
  SmallSubFormContainer: styled.div`
    position: relative;
    width: 500px;
    z-index: 3;
  `,
  SearchFormContainer: styled.div`
    padding-top: 26px;
    width: 300px;
    z-index: 2;
  `,
  ButtonContainer: styled.div`
    padding-top: 26px;
    width: 200px;
    z-index: 2;
  `
};

const BackToExploreButton = ({ onClick, isVisible }) => {
  if (onClick && isVisible) {
    return (
      <Styled.BackButton
        color="white"
        iconStart={<CaretLeftSmall />}
        naked
        onClick={onClick}
      >
        <Translation id="explore.back-to-explore">Back to Explore</Translation>
      </Styled.BackButton>
    );
  }
  return null;
};

const HeroTitle = ({
  actionButton,
  allPromos,
  backToExplore,
  hasVbidInUrl,
  onExploreRoute,
  showSearch,
  subscriptionDescription,
  subscriptionImage,
  subscriptionName,
  subscriptionVbid,
  nativePlatform
}) => {
  const currentSub = allPromos[subscriptionVbid] || {};
  const titleText = subscriptionName || currentSub.title;
  const defaultImage = titleText ? "/img/explore-header-bg.jpg" : ""
  const backgroundImage =
    subscriptionImage || currentSub.cover || defaultImage;
  const description = subscriptionDescription || currentSub.description;

  return (
    <Styled.HeroContainer backgroundImage={backgroundImage} titleText={titleText}>
      <BackToExploreButton
        onClick={backToExplore}
        isVisible={onExploreRoute && hasVbidInUrl}
      />
      <Styled.Header>
        {titleText && <span>{titleText}</span>}
        {!titleText && (
          <Translation id="explore.explore-new-titles">
            Explore new titles!
          </Translation>
        )}
      </Styled.Header>
      <Styled.Description>
        <span dangerouslySetInnerHTML={{__html: description}} />
      </Styled.Description>
      {nativePlatform !== "web" && showSearch && (
        <Styled.SearchFormContainer>
          <SearchForm />
        </Styled.SearchFormContainer>
      )}
      {actionButton && (
        <Styled.ButtonContainer>
          <Button size="large" fullWidth onClick={actionButton.action}>
            {actionButton.label}
          </Button>
        </Styled.ButtonContainer>
      )}
    </Styled.HeroContainer>
  );
};

const mapLicenseStateToProps = (state, props) => ({
  subscriptionName: bridgeSelectors.getSubscriptionName(
    state,
    props.subscriptionVbid
  ),
  subscriptionDescription: bridgeSelectors.getSubscriptionDescription(
    state,
    props.subscriptionVbid
  ),
  subscriptionImage: bridgeSelectors.getSubscriptionImage(
    state,
    props.subscriptionVbid
  ),
  hasVbidInUrl: getSubscriptionFromRoute(state),
  onExploreRoute: getCurrentRoute(state).hash.indexOf("/explore/") >= 0,
  allPromos: bridgeSelectors.getPromotionsAsObject(state),
  nativePlatform: routerSelectors.getQueryParam(state, "platform")
});

export default connect(mapLicenseStateToProps, null)(HeroTitle);
